
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/freight-templates/packing-list",
      function () {
        return require("private-next-pages/resources/freight-templates/packing-list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/freight-templates/packing-list"])
      });
    }
  